
import { defineComponent, SetupContext, ref, ComponentPublicInstance, onMounted, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsSelectHours",
  props: {
    isShowSelectHours: {
      type: Boolean,
      required: true
    },
    initialHour: {
      type: Number,
      required: true
    },
    minHour: {
      type: Number,
      required: true
    },
    maxHour: {
      type: Number,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    // 現在の設定時間
    let currentHour = 0;

    interface HTMLElementEvent<T extends HTMLElement> extends Event {
      target: T;
    }
    type HTMLDivElementEvent = HTMLElementEvent<HTMLDivElement>;

    // ツールバー
    const cancelButtonText = "キャンセル";
    const setButtonText = "完了";
    const clickCancel = () => {
      context.emit("click-cancel")
    }
    const clickSet = () => {
      context.emit("click-complete", currentHour);
    };

    // コンテンツ生成
    interface FridgeDetailsDrumPickerContents {
      index: number;
      value: number;
      displayText: string;
    }
    const hoursContent = computed(() => {
      const result: Array<FridgeDetailsDrumPickerContents> = [];
      let index = 0;
      for (let value = props.minHour; value <= props.maxHour; value ++) {
        const element: FridgeDetailsDrumPickerContents = { index: index, value: value, displayText: `${value}時間` };
        result.push(element);
        index ++;
      }
      return result;
    });

    // 時間スクロール
    const hoursScroll = ref<ComponentPublicInstance<HTMLInputElement>>();
    const hoursParentContent = ref<ComponentPublicInstance<HTMLElement>>();
    let hoursTimerId: number | null = null;
    const findExactElementIndex = () => {
      if (hoursScroll.value == undefined || hoursScroll.value == null || hoursParentContent.value == undefined || hoursParentContent.value == null) {
        return null;
      }
      const scrollRect = hoursScroll.value.getBoundingClientRect();
      const scrollVerticalCenter = scrollRect.top + scrollRect.height / 2;
      const elements = hoursParentContent.value.children;
      const items = Array.from(elements);
      for (let index = 0; index < items.length; index ++) {
        const element = items[index];
        const clientRect = element.getBoundingClientRect();
        if (clientRect.top < scrollVerticalCenter && scrollVerticalCenter <= clientRect.bottom) {
          return index;
        }
      }
      return null;
    };
    const setHoursDrumScrollTo = (position: number, isSmooth: boolean) => {
      NativeClient.sendDebugLog("FridgeDetailsSelectHours setHoursDrumScrollTo position = " + position);
      if (hoursScroll.value == undefined || hoursScroll.value == null || hoursParentContent.value == undefined || hoursParentContent.value == null) {
        NativeClient.sendDebugLog("FridgeDetailsSelectHours setHoursDrumScrollTo no exist element");
        return;
      }
      const elements = hoursParentContent.value.children;
      const items = Array.from(elements);
      if (isSmooth) {
        hoursScroll.value.scrollTo({ top: (items[position].clientHeight * position), left: 0, behavior: 'smooth' });
      } else {
        NativeClient.sendDebugLog("FridgeDetailsSelectHours setHoursDrumScrollTo no smooth");
        hoursScroll.value.scrollTo({ top: (items[position].clientHeight * position), left: 0 });
      }
    };
    const onScrollEnd = () => {
      hoursTimerId = null;
      NativeClient.sendDebugLog("FridgeDetailsSelectHours onScrollEnd start");
      if (hoursScroll.value != undefined && hoursParentContent.value != undefined) {
        // スクロール領域の情報取得
        NativeClient.sendDebugLog("FridgeDetailsSelectHours onScrollEnd valid");
        const index = findExactElementIndex();
        if (index != null) {
          currentHour = index + props.minHour;
          NativeClient.sendDebugLog("FridgeDetailsSelectHours onScrollEnd currentHour = " + currentHour);
        }
      }
    };
    const onScroll = (event: HTMLDivElementEvent) => {
      NativeClient.sendDebugLog("FridgeDetailsSelectHours onScroll");
      if (hoursTimerId != null) {
        clearTimeout(hoursTimerId);
      }
      hoursTimerId = window.setTimeout(onScrollEnd, 50);
    };

    const setInitial = (initValue: number, minValue: number) => {
      const initialPosition = initValue - minValue;
      NativeClient.sendDebugLog("FridgeDetailsSelectHours setInitial = " + initialPosition);
      currentHour = initValue;
      if (initialPosition >= 0) {
        setHoursDrumScrollTo(initialPosition, false);
      } else {
        setHoursDrumScrollTo(0, false);
      }
      NativeClient.sendDebugLog("FridgeDetailsSelectHours setInitial end");
    };

    onMounted(() => {
      setInitial(props.initialHour, props.minHour);
    });

    return {
      cancelButtonText,
      setButtonText,
      clickCancel,
      clickSet,
      onScroll,
      hoursScroll,
      hoursContent,
      hoursParentContent
    };
  }
});
